import React, { useEffect } from "react";
import HomeContent from "../../components/home/content";
import RootLayout from "../layout";
import { updateAllLayouts } from "@noriginmedia/norigin-spatial-navigation";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../../redux/Slices/loading.slice";
import PageLayout from "../../components/layout/PageLayout";
import { useShowcaseCacheWithConfig } from "../../utils/hooks/useShowcaseCache";

var MusicHome = function () {
    var dispatch = useDispatch();

    var cacheResult = useShowcaseCacheWithConfig({
        cacheKey: "music",
        configKey: "music",
        versionTitle: "music",
    });

    var musicData = cacheResult.data;
    var loading = cacheResult.loading;

    // Handle loading state for sidebar
    useEffect(function () {
        if (loading) {
            dispatch(startLoading("در حال بارگذاری موسیقی‌ها..."));
        } else {
            dispatch(stopLoading());
            updateAllLayouts();
        }
    }, [loading, dispatch]);

    return (
        <RootLayout>
            <PageLayout loading={loading} skeletonType="showcase">
                {musicData && <HomeContent showCaseData={musicData} isShowcasePage={true} contentKind="music" />}
            </PageLayout>
        </RootLayout>
    );
};

export default MusicHome;
